/**
 * No.202: 治療状態タイムライン
 * user_treatment_state_transitions の state 値を日本語ラベルに変換するマッピング
 */
export const TREATMENT_STATE_LABELS: Record<string, string> = {
  selected_treatment: '診療科目選択日時',
  registered_interview: '問診回答日時',
  no_need_interview: '問診不要',
  subscription_suggestions: '問診後処方不可',
  choice_interview_method: '診察方法選択日時',
  chat_interview_scheduled: 'チャット診察予約日時',
  video_interview_scheduled: 'ビデオ診察予約日時',
  confirmed_reservation: '診察予約確定日時',
  video_interview_date: 'ビデオ診察予約日時',
  confirming_prescription: '処方内容 確認中',
  not_paid: '決済情報入力前',
  success_paid: '決済完了（初回）',
  card_registered: '支払いカード登録日時',
  subscription_not_paid: '未決済（定期）',
  subscription_success_paid: '決済完了（定期）',
  subscription_contract: '定期購入 契約成立',
  doctor_prescription_ok: '医師処方OK日時',
  doctor_prescription_check: '最終処方確認移行日時',
  canceled: 'キャンセル日時',
  doctor_cancel_prescription: '処方キャンセル日時',
  doctor_reserve_prescription: '処方保留日時',
  doctor_requested_video_call: 'ビデオ診察依頼日時',
  choose_resolution_date_from_doctor_request: 'ビデオ診察予約を行った日時',
  appointment_pending_questions: '追加質問 回答待ち',
  awaiting_plan: 'プラン選択待ち',
  chat_consultation_in_progress: 'チャット診察開始日時',
  cancel_requested: 'キャンセル申請日時',
};

/**
 * state 値を日本語ラベルに変換する。
 * マッピングに存在しない state の場合はそのまま返す。
 */
export function getTreatmentStateLabel(state: string): string {
  return TREATMENT_STATE_LABELS[state] ?? state;
}
